import { render, staticRenderFns } from "./IssuesListItem.vue?vue&type=template&id=1d592dc0&scoped=true&"
import script from "./IssuesListItem.vue?vue&type=script&lang=js&"
export * from "./IssuesListItem.vue?vue&type=script&lang=js&"
import style0 from "./IssuesListItem.vue?vue&type=style&index=0&id=1d592dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d592dc0",
  null
  
)

export default component.exports